<template>
    <div :class="{'someclass': content.blockfontsize == 'large'}"  v-if="readonly == false || content.pagetext != ''">
        <div class="d-none">{{newPageTextCheck}}</div>
        <div v-if="readonly && !foundFeatureMeta" v-html="newPageText"></div>
        <div v-if="readonly && foundFeatureMeta" v-html="newPageText[0]"></div>
        <feature-li v-if="readonly && foundFeatureMeta" :readonly="readonly" :featuremeta="foundFeatureMeta" :pageid="content._id" :websiteid="websiteid"/>
        <div v-if="readonly &&foundFeatureMeta" v-html="newPageText[1]"></div>
        
        <inline-editor v-if="!readonly" :editable="content.pagetext" :pageid="content._id" dbentry="pagetext" element="textarea"/>
    </div>
</template>

<script>
import InlineEditor from '../app/InlineEditor.vue';
import FeatureLi from '../content/FeatureLi.vue';
export default {
    components:{
        InlineEditor,
        FeatureLi
    },
    props: {
        content: Object,
        websiteid: String,
        readonly: Boolean
    },
    data: function() {
        return{
            foundFeatureMeta: '',
            newPageText: ''
        }
    },
    computed:{
        newPageTextCheck: function(){
            //  [feature-Vacancies, 8, images, nodesc, meta end/]
            const ogcontent = this.content.pagetext
            const featurestringstart = "[feature-"
            const endstring = "end/]"

            if(ogcontent.includes(featurestringstart) == true){
                const featureString = ogcontent.substring(
                    ogcontent.lastIndexOf(featurestringstart),
                    ogcontent.lastIndexOf(endstring) + 5
                )
                const feature = ogcontent.substring(
                    ogcontent.lastIndexOf(featurestringstart) + 9,
                    ogcontent.lastIndexOf(endstring)
                )
                this.foundFeatureMeta = feature.split(', ')
                this.newPageText = ogcontent.split(featureString)
                return 'y'
            } else {
                this.newPageText = ogcontent
                return 'n'
            }
        }
    }
}
</script>

